import pathfinder from '@fiverr-private/pathfinder';
import { getBriefParams } from '../../../page/components/BuyerIdeas/lib';

interface GetBriefUrlParams {
    brandName?: string;
    slogan?: string;
    tagId?: string;
    tagType?: string;
}

export const getBriefUrl = ({ brandName, slogan, tagId, tagType }: GetBriefUrlParams = {}) =>
    pathfinder(
        'logo_maker_brief_page_logo_maker_brief_step_name',
        { step_name: 'logo_name' },
        { query: getBriefParams({ brandName, slogan, tagId, tagType }) }
    );
